
    import { defineComponent, provide } from 'vue';
    import CovidEndpointHeader from '../components/covid-endpoint-header.vue';
    import CovidEndpointContent from '../components/covid-endpoint-content.vue';
	import CovidEndpointNavigation from '../components/covid-endpoint-navigation.vue';
    import CovidEndpointFooter from '../components/covid-endpoint-footer.vue';
	import CovidEndpointSectionNavigation from '../components/covid-endpoint-section-navigation.vue';
	import CovidSectionPages from '../components/covid-section-pages.vue';

	import { covidEndpointComposition } from '../services';

    export default defineComponent({
        name: 'covid-hub-endpoint',
        components: {
			CovidEndpointHeader,
			CovidEndpointContent,
			CovidEndpointNavigation,
			CovidEndpointFooter,
			CovidEndpointSectionNavigation,
			CovidSectionPages
		},
		setup () {
			const composition = covidEndpointComposition();
			provide('endpointData', composition.endpointData);

			return { ...composition }
		},
    })
